import { useState } from 'react';

export default function ServiceArea() {
  const [selectedArea, setSelectedArea] = useState<string | null>(null);

  const fukuokaAreas = {
    fukuoka: {
      name: '福岡エリア',
      cities: [
        '福岡市博多区', '福岡市中央区', '福岡市南区', '福岡市東区', 
        '福岡市西区', '福岡市城南区', '福岡市早良区',
        '春日市', '大野城市', '太宰府市', '筑紫野市', '那珂川市'
      ]
    },
    kitakyushu: {
      name: '北九州エリア',
      cities: [
        '北九州市小倉北区', '北九州市小倉南区', '北九州市門司区',
        '北九州市若松区', '北九州市八幡東区', '北九州市八幡西区', '北九州市戸畑区',
        '行橋市', '豊前市', '中間市', '遠賀郡', '京都郡'
      ]
    },
    chikuho: {
      name: '筑豊エリア',
      cities: [
        '飯塚市', '田川市', '直方市', '宮若市', '嘉麻市',
        '鞍手郡', '嘉穂郡', '田川郡'
      ]
    },
    chikugo: {
      name: '筑後エリア',
      cities: [
        '久留米市', '大牟田市', '柳川市', '八女市', '筑後市',
        '大川市', 'みやま市', '小郡市', 'うきは市', '朝倉市',
        '三井郡', '三潴郡', '八女郡'
      ]
    }
  };

  const yamaguchiAreas = {
    west: {
      name: '西部エリア',
      cities: [
        '下関市', '長門市', '美祢市', '山陽小野田市'
      ]
    },
    east: {
      name: '東部エリア',
      cities: [
        '岩国市', '柳井市', '光市', '周南市', '下松市'
      ]
    },
    central: {
      name: '中部エリア',
      cities: [
        '山口市', '宇部市', '萩市', '防府市'
      ]
    }
  };

  const sagaAreas = {
    central: {
      name: '中部エリア',
      cities: [
        '佐賀市', '小城市', '多久市', '神埼市', '神埼郡'
      ]
    },
    east: {
      name: '東部エリア',
      cities: [
        '鳥栖市', '三養基郡'
      ]
    },
    northwest: {
      name: '北西部エリア',
      cities: [
        '唐津市', '東松浦郡'
      ]
    },
    south: {
      name: '南部エリア',
      cities: [
        '鹿島市', '嬉野市', '藤津郡'
      ]
    },
    west: {
      name: '西部エリア',
      cities: [
        '伊万里市', '武雄市', '杵島郡', '西松浦郡'
      ]
    }
  };

  const oitaAreas = {
    north: {
      name: '北部エリア',
      cities: [
        '中津市', '豊後高田市', '宇佐市', '国東市', '東国東郡'
      ]
    },
    central: {
      name: '中部エリア',
      cities: [
        '大分市', '別府市', '杵築市', '由布市', '速見郡'
      ]
    },
    west: {
      name: '西部エリア',
      cities: [
        '日田市', '玖珠郡'
      ]
    },
    south: {
      name: '南部エリア',
      cities: [
        '佐伯市', '臼杵市', '津久見市', '竹田市', '豊後大野市'
      ]
    }
  };

  const nagasakiAreas = {
    nagasaki: {
      name: '長崎エリア',
      cities: [
        '長崎市', '西海市', '西彼杵郡'
      ]
    },
    sasebo: {
      name: '佐世保エリア',
      cities: [
        '佐世保市', '平戸市', '松浦市', '北松浦郡'
      ]
    },
    shimabara: {
      name: '島原エリア',
      cities: [
        '島原市', '雲仙市', '南島原市'
      ]
    },
    omura: {
      name: '大村・諫早 エリア',
      cities: [
        '諫早市', '大村市', '東彼杵郡'
      ]
    },
    islands: {
      name: '離島エリア',
      cities: [
        '対馬市', '壱岐市', '五島市', '南松浦郡'
      ]
    }
  };

  const kumamotoAreas = {
    kumamoto: {
      name: '熊本エリア',
      cities: [
        '熊本市中央区', '熊本市東区', '熊本市西区', '熊本市南区', '熊本市北区',
        '合志市', '菊陽町', '大津町'
      ]
    },
    north: {
      name: '県北エリア',
      cities: [
        '荒尾市', '玉名市', '山鹿市', '菊池市', '玉名郡', '菊池郡'
      ]
    },
    aso: {
      name: '阿蘇エリア',
      cities: [
        '阿蘇市', '南小国町', '小国町', '産山村', '高森町', '西原村', '南阿蘇村'
      ]
    },
    central: {
      name: '県央エリア',
      cities: [
        '宇土市', '宇城市', '美里町', '御船町', '嘉島町', '益城町', '甲佐町', '山都町'
      ]
    },
    yatsushiro: {
      name: '八代エリア',
      cities: [
        '八代市', '氷川町'
      ]
    },
    ashikita: {
      name: '芦北エリア',
      cities: [
        '水俣市', '芦北町', '津奈木町'
      ]
    },
    kuma: {
      name: '球磨エリア',
      cities: [
        '人吉市', '錦町', '多良木町', '湯前町', '水上村', '相良村', '五木村', '山江村', '球磨村', 'あさぎり町'
      ]
    },
    amakusa: {
      name: '天草エリア',
      cities: [
        '天草市', '上天草市', '苓北町'
      ]
    }
  };

  const scrollToArea = (areaId: string) => {
    setSelectedArea(areaId);
    setTimeout(() => {
      const element = document.getElementById(areaId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  return (
    <section id="area" className="py-20 bg-gradient-to-b from-pink-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">対応エリア</h2>
          <p className="text-xl text-gray-600">
            九州エリアを中心に幅広く対応しております
          </p>
        </div>

        {/* 福岡県エリア選択ボタン */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">福岡県</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
            {Object.entries(fukuokaAreas).map(([key, area]) => (
              <button
                key={key}
                onClick={() => scrollToArea(key)}
                className="bg-white hover:bg-green-50 border-2 border-green-600 text-green-700 px-6 py-4 rounded-lg font-bold text-lg transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                {area.name}
              </button>
            ))}
          </div>
        </div>

        {/* 福岡県詳細エリア */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {Object.entries(fukuokaAreas).map(([key, area]) => (
            <div 
              key={key}
              id={key}
              className={`bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all border-2 ${
                selectedArea === key ? 'border-green-600 ring-4 ring-green-200' : 'border-pink-100'
              }`}
            >
              <div className="flex items-center gap-3 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">{area.name}</h3>
              </div>
              <ul className="space-y-3">
                {area.cities.map((city, cityIndex) => (
                  <li key={cityIndex} className="text-gray-700">
                    <div className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-600 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                      <div className="flex flex-wrap gap-1">
                        <span className="text-xs bg-pink-100 text-pink-700 px-2 py-0.5 rounded">
                          {city}遺品整理
                        </span>
                        <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                          {city}生前整理
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 山口県エリア選択ボタン */}
        <div className="mb-12 mt-16">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">山口県</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-5xl mx-auto">
            {Object.entries(yamaguchiAreas).map(([key, area]) => (
              <button
                key={key}
                onClick={() => scrollToArea(key)}
                className="bg-white hover:bg-green-50 border-2 border-green-600 text-green-700 px-6 py-4 rounded-lg font-bold text-lg transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                {area.name}
              </button>
            ))}
          </div>
        </div>

        {/* 山口県詳細エリア */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {Object.entries(yamaguchiAreas).map(([key, area]) => (
            <div 
              key={key}
              id={key}
              className={`bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all border-2 ${
                selectedArea === key ? 'border-green-600 ring-4 ring-green-200' : 'border-pink-100'
              }`}
            >
              <div className="flex items-center gap-3 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">{area.name}</h3>
              </div>
              <ul className="space-y-3">
                {area.cities.map((city, cityIndex) => (
                  <li key={cityIndex} className="text-gray-700">
                    <div className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-600 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                      <div className="flex flex-wrap gap-1">
                        <span className="text-xs bg-pink-100 text-pink-700 px-2 py-0.5 rounded">
                          {city}遺品整理
                        </span>
                        <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                          {city}生前整理
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 佐賀県エリア選択ボタン */}
        <div className="mb-12 mt-16">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">佐賀県</h3>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 max-w-5xl mx-auto">
            {Object.entries(sagaAreas).map(([key, area]) => (
              <button
                key={key}
                onClick={() => scrollToArea(key)}
                className="bg-white hover:bg-green-50 border-2 border-green-600 text-green-700 px-6 py-4 rounded-lg font-bold text-lg transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                {area.name}
              </button>
            ))}
          </div>
        </div>

        {/* 佐賀県詳細エリア */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {Object.entries(sagaAreas).map(([key, area]) => (
            <div 
              key={key}
              id={key}
              className={`bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all border-2 ${
                selectedArea === key ? 'border-green-600 ring-4 ring-green-200' : 'border-pink-100'
              }`}
            >
              <div className="flex items-center gap-3 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">{area.name}</h3>
              </div>
              <ul className="space-y-3">
                {area.cities.map((city, cityIndex) => (
                  <li key={cityIndex} className="text-gray-700">
                    <div className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-600 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                      <div className="flex flex-wrap gap-1">
                        <span className="text-xs bg-pink-100 text-pink-700 px-2 py-0.5 rounded">
                          {city}遺品整理
                        </span>
                        <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                          {city}生前整理
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 大分県エリア選択ボタン */}
        <div className="mb-12 mt-16">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">大分県</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
            {Object.entries(oitaAreas).map(([key, area]) => (
              <button
                key={key}
                onClick={() => scrollToArea(key)}
                className="bg-white hover:bg-green-50 border-2 border-green-600 text-green-700 px-6 py-4 rounded-lg font-bold text-lg transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                {area.name}
              </button>
            ))}
          </div>
        </div>

        {/* 大分県詳細エリア */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {Object.entries(oitaAreas).map(([key, area]) => (
            <div 
              key={key}
              id={key}
              className={`bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all border-2 ${
                selectedArea === key ? 'border-green-600 ring-4 ring-green-200' : 'border-pink-100'
              }`}
            >
              <div className="flex items-center gap-3 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">{area.name}</h3>
              </div>
              <ul className="space-y-3">
                {area.cities.map((city, cityIndex) => (
                  <li key={cityIndex} className="text-gray-700">
                    <div className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-600 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                      <div className="flex flex-wrap gap-1">
                        <span className="text-xs bg-pink-100 text-pink-700 px-2 py-0.5 rounded">
                          {city}遺品整理
                        </span>
                        <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                          {city}生前整理
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 長崎県エリア選択ボタン */}
        <div className="mb-12 mt-16">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">長崎県</h3>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 max-w-5xl mx-auto">
            {Object.entries(nagasakiAreas).map(([key, area]) => (
              <button
                key={key}
                onClick={() => scrollToArea(key)}
                className="bg-white hover:bg-green-50 border-2 border-green-600 text-green-700 px-6 py-4 rounded-lg font-bold text-lg transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                {area.name}
              </button>
            ))}
          </div>
        </div>

        {/* 長崎県詳細エリア */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {Object.entries(nagasakiAreas).map(([key, area]) => (
            <div 
              key={key}
              id={key}
              className={`bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all border-2 ${
                selectedArea === key ? 'border-green-600 ring-4 ring-green-200' : 'border-pink-100'
              }`}
            >
              <div className="flex items-center gap-3 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">{area.name}</h3>
              </div>
              <ul className="space-y-3">
                {area.cities.map((city, cityIndex) => (
                  <li key={cityIndex} className="text-gray-700">
                    <div className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-600 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                      <div className="flex flex-wrap gap-1">
                        <span className="text-xs bg-pink-100 text-pink-700 px-2 py-0.5 rounded">
                          {city}遺品整理
                        </span>
                        <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                          {city}生前整理
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 熊本県エリア選択ボタン */}
        <div className="mb-12 mt-16">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">熊本県</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
            {Object.entries(kumamotoAreas).map(([key, area]) => (
              <button
                key={key}
                onClick={() => scrollToArea(key)}
                className="bg-white hover:bg-green-50 border-2 border-green-600 text-green-700 px-6 py-4 rounded-lg font-bold text-lg transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                {area.name}
              </button>
            ))}
          </div>
        </div>

        {/* 熊本県詳細エリア */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {Object.entries(kumamotoAreas).map(([key, area]) => (
            <div 
              key={key}
              id={key}
              className={`bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all border-2 ${
                selectedArea === key ? 'border-green-600 ring-4 ring-green-200' : 'border-pink-100'
              }`}
            >
              <div className="flex items-center gap-3 mb-6">
                <h3 className="text-2xl font-bold text-gray-800">{area.name}</h3>
              </div>
              <ul className="space-y-3">
                {area.cities.map((city, cityIndex) => (
                  <li key={cityIndex} className="text-gray-700">
                    <div className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-600 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                      <div className="flex flex-wrap gap-1">
                        <span className="text-xs bg-pink-100 text-pink-700 px-2 py-0.5 rounded">
                          {city}遺品整理
                        </span>
                        <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                          {city}生前整理
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-pink-50 p-8 rounded-xl border border-pink-200">
          <div className="flex items-start gap-4">
            <i className="ri-information-fill text-green-600 text-3xl mt-1 w-8 h-8 flex items-center justify-center flex-shrink-0"></i>
            <div>
              <h4 className="text-xl font-bold text-gray-800 mb-3">対応エリアについて</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                  <span>上記エリア以外でも対応可能な場合がございます。お気軽にご相談ください。</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                  <span>遠方の場合は出張費が発生する場合がございます。詳しくはお問い合わせください。</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                  <span>緊急のご依頼にも可能な限り対応させていただきます。</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <a 
            href="#contact" 
            className="inline-block bg-green-600 hover:bg-green-700 text-white px-10 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            お気軽にお問い合わせください
          </a>
        </div>
      </div>
    </section>
  );
}
